import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query IntegrationAuthStatus {
    me {
      integrationAuthStatus {
        dataSource
        authState
      }
    }
  }
`;

export const queryIntegrationAuthStatus = async () => {
  const result = await executeGqlQuery({
    query: QUERY,
  });
  return getSingleProp(result.data);
};
